import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default async function perdasHeaderLocalizacaoReport(
    visita,
    indicador,
    apontamento,
    params,
    optLabelConformidade,
    indicadorType,
) {
    const h = new TableReportHelper(apontamento);
    const georeferencia = apontamento?.georeferencia;
    const IndicadorClass = indicador.constructor;
    if (!params) {
        return null;
    }

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;
    const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                    await h.locationImageFieldHeaderOnly(georeferencia),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    let titleAr = [h.title("Talhão"), h.title("Área (ha)")];
    let valueAr = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];

    if (apontamento.variedade) {
        titleAr.push(h.title("Variedade"));
        valueAr.push(h.textField("variedade.variedade"));
    }

    if (apontamento.corte) {
        titleAr.push(h.title("Corte"));
        valueAr.push(h.textField("corte"));
    }

    titleAr.push(h.title("TCH"));
    titleAr.push(h.title("Frota"));
    titleAr.push(h.title("Frente"));
    titleAr.push(h.title("Turno"));
    if (indicadorType.field === "colheitas" || indicadorType.field === "plantio") {
        titleAr.push(h.title("Operador"));
    }

    valueAr.push(h.textField("tch"));
    valueAr.push(h.textField("frota.numeroFrotaTrator"));
    valueAr.push(h.textField("frente"));
    valueAr.push(h.textField("turno"));
    if (indicadorType.field === "colheitas" || indicadorType.field === "plantio") {
        valueAr.push(h.textField("operador.operador"));
    }

    const arr = titleAr.map((ta, i) => {
        let arr2 = h.row(ta, valueAr[i]);
        return arr2;
    });

    const p1content = [
        h.row(h.title("Amostra"), h.text(nomeAmostra)),
        h.row(h.title("Tipo"), h.textField("tipo")),
        h.row(h.title(`Meta (${IndicadorClass.quantifierMeta || "%"})`), h.text(params.meta)),
    ];

    const content = [];

    content.push([h.panel(p1content, { widths: [100, "*"] }), h.panel(arr, { widths: [100, "*"] })]);

    const panelMapa = [];

    panelMapa.push(
        h.panel([h.row(h.unbreakable(content), await h.locationImageFieldHeaderOnly(georeferencia))], {
            widths: ["*", 210],
        }),
    );

    const conditionalColetasTitle = [];
    const conditionalColetasValues = [];
    const conditionalColetasWidth = [];

    if (params.hasOwnProperty("toco") && params["toco"] === true) {
        conditionalColetasTitle.push(h.title("Toco (g)"));
        conditionalColetasValues.push(h.textField("toco"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("tocoIndireto") && params["tocoIndireto"] === true) {
        conditionalColetasTitle.push(h.title("Toco Indireto (g)"));
        conditionalColetasValues.push(h.textField("tocoIndireto"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("ponteiro") && params["ponteiro"] === true) {
        conditionalColetasTitle.push(h.title("Ponteiro (g)"));
        conditionalColetasValues.push(h.textField("ponteiro"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("canaInteira") && params["canaInteira"] === true) {
        conditionalColetasTitle.push(h.title("Cana Inteira (g)"));
        conditionalColetasValues.push(h.textField("canaInteira"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("canaFixa") && params["canaFixa"] === true) {
        conditionalColetasTitle.push(h.title("Cana/Pedaço Fixo (g)"));
        conditionalColetasValues.push(h.textField("canaFixa"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("estilhaco") && params["estilhaco"] === true) {
        conditionalColetasTitle.push(h.title("Estilhaço (g)"));
        conditionalColetasValues.push(h.textField("estilhaco"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("tolete") && params["tolete"] === true) {
        conditionalColetasTitle.push(h.title("Tolete (g)"));
        conditionalColetasValues.push(h.textField("tolete"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("pedaco") && params["pedaco"] === true) {
        conditionalColetasTitle.push(h.title("Pedaço (g)"));
        conditionalColetasValues.push(h.textField("pedaco"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("lasca") && params["lasca"] === true) {
        conditionalColetasTitle.push(h.title("Lasca (g)"));
        conditionalColetasValues.push(h.textField("lasca"));
        conditionalColetasWidth.push("*");
    }
    if (params.hasOwnProperty("toleteEstilhacado") && params["toleteEstilhacado"] === true) {
        conditionalColetasTitle.push(h.title("Tolete Estilhaçado (g)"));
        conditionalColetasValues.push(h.textField("toleteEstilhacado"));
        conditionalColetasWidth.push("*");
    }

    panelMapa.push(
        h.panel([
            // prettier-ignore
            h.row(
                h.title("COLETAS")
            ),
        ]),

        h.panel(
            [
                h.row(
                    conditionalColetasTitle,
                    // h.title("Toco (g)"),
                    // h.title("Ponteiro (g)"),
                    // h.title("Cana Inteira (g)"),
                    // h.title("Cana/Pedaço Fixo (g)"),
                    // h.title("Estilhaço (g)"),
                    // h.title("Tolete (g)"),
                    // h.title("Pedaço (g)"),
                    // h.title("Lasca (g)"),
                    // h.title("Tolete Estilhaçado (g)"),
                ),

                h.row(
                    conditionalColetasValues,
                    // h.textField("toco"),
                    // h.textField("ponteiro"),
                    // h.textField("canaInteira"),
                    // h.textField("canaFixa"),
                    // h.textField("estilhaco"),
                    // h.textField("tolete"),
                    // h.textField("pedaco"),
                    // h.textField("lasca"),
                    // h.textField("toleteEstilhacado"),
                ),
            ],
            {
                widths: conditionalColetasWidth,
                // "*", // 35, // Toco
                // "*", // Ponteiro
                // "*", // Cana Inteira
                // "*", // Cana/Pedaço Fixo
                // "*", // Estilhaço
                // "*", // Tolete
                // "*", // Pedaço
                // "*", // Lasca
                // "*", // Tolete Estilhaçado
            },
        ),

        h.panel(
            [
                h.row(
                    h.title("Total de Perdas (g)", { alignment: "right" }),
                    h.textField("totalPerdas"),
                    h.title(optLabelConformidade || "Perdas (%)"),
                    h.conformidadeField("conformidade", status, { alignment: "right" }),
                ),
            ],
            { widths: ["*", 80, 80, 80] },
        ),
    );

    return panelMapa;
}
